if (!customElements.get('godshot-header-menu')) {
  class GodshotHeaderMenu extends HTMLElement {
    connectedCallback() {
      this.toggleButton = this.querySelector('[data-godshot-menu-toggle]');
      this.submenu = this.querySelector('[data-godshot-menu-submenu]');

      if (!this.toggleButton || !this.submenu) return;

      this.onMouseEnter = this.handleMouseEnter.bind(this);
      this.onMouseLeave = this.handleMouseLeave.bind(this);
      this.onToggleClick = this.toggle.bind(this);
      this.onFocusOut = this.handleFocusOut.bind(this);
      this.onKeyDown = this.handleKeyDown.bind(this);
      this.onDocumentClick = this.handleDocumentClick.bind(this);

      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
      this.addEventListener('focusout', this.onFocusOut);
      this.addEventListener('keydown', this.onKeyDown);
      this.toggleButton.addEventListener('click', this.onToggleClick);
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onMouseEnter);
      this.removeEventListener('mouseleave', this.onMouseLeave);
      this.removeEventListener('focusout', this.onFocusOut);
      this.removeEventListener('keydown', this.onKeyDown);
      this.toggleButton?.removeEventListener('click', this.onToggleClick);
      document.removeEventListener('click', this.onDocumentClick);
    }

    open() {
      this.classList.add('is-open');
      this.toggleButton.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.classList.remove('is-open');
      this.toggleButton.setAttribute('aria-expanded', 'false');
    }

    toggle(event) {
      event.preventDefault();
      event.stopPropagation();
      this.classList.contains('is-open') ? this.close() : this.open();
    }

    handleMouseEnter() {
      this.toggleButton.setAttribute('aria-expanded', 'true');
    }

    handleMouseLeave() {
      if (!this.classList.contains('is-open') && !this.contains(document.activeElement)) {
        this.toggleButton.setAttribute('aria-expanded', 'false');
      }
    }

    handleFocusOut() {
      window.setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }

    handleKeyDown(event) {
      if (event.key !== 'Escape') return;
      this.close();
      this.toggleButton.focus();
    }

    handleDocumentClick(event) {
      if (!this.contains(event.target)) this.close();
    }
  }

  customElements.define('godshot-header-menu', GodshotHeaderMenu);
}
